module.exports = __webpack_public_path__ + "img/logo-white.c65eb1e3.png";